module.exports = __webpack_public_path__ + "static/media/ALL-trialrepeat-the-word.4d97043e.mp3";